export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "new_subscription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effectuer une souscription"])}
      },
      "en": {
        "new_subscription": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Make a subscription"])}
      }
    }
  })
}
